import "./PhoneInput.scss";

import BasePhoneInput, {
	Country,
	Props as BasePhoneInputProps,
} from "react-phone-number-input";
import React, { useCallback, useMemo, useState } from "react";
import clsx from "clsx";

export interface PhoneFieldMeta {
	country?: string;
}

export interface PhoneInputProps extends Omit<BasePhoneInputProps, "onChange"> {
	value?: string;
	onChange?: (value: string | undefined, meta?: PhoneFieldMeta) => void;
	defaultValue?: string;
	meta?: PhoneFieldMeta;
	defaultMeta?: PhoneFieldMeta;
}

const PhoneInput = (props: PhoneInputProps) => {
	const {
		meta,
		className,
		defaultMeta,
		value: propsValue,
		defaultValue,
		onChange,
		...otherProps
	} = props;

	let defaultCountry = defaultMeta?.country;
	if (defaultCountry?.toLowerCase() === "uk") {
		defaultCountry = "GB";
	}

	const [stateValue, setStateValue] = useState(defaultValue);
	const [, setCountry] = useState(defaultCountry);

	const value = useMemo(() => {
		if (propsValue !== undefined) {
			return propsValue;
		}
		return stateValue;
	}, [propsValue, stateValue]);

	const handleCountryChange = useCallback(
		(country: Country) => {
			setCountry(country);
			if (onChange) {
				onChange(value, { country });
			}
		},
		[onChange, value],
	);

	const handleValueChange = useCallback(
		(value: string) => {
			setStateValue(value);
			if (onChange) {
				onChange(value);
			}
		},
		[onChange],
	);

	return (
		<BasePhoneInput
			className={clsx(className, "Field__input")}
			onChange={handleValueChange}
			onCountryChange={handleCountryChange}
			defaultCountry={defaultCountry as any}
			{...otherProps}
			value={value}
		/>
	);
};

export default PhoneInput;
